import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldAlert } from 'lucide-react';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('lgpd_consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('lgpd_consent', 'all');
    setIsVisible(false);
  };

  const handleAcceptEssential = () => {
    localStorage.setItem('lgpd_consent', 'essential');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-8 z-[100] md:max-w-md"
        >
          <div className="bg-white border border-brand-slate/10 shadow-2xl rounded-xl p-6 pointer-events-auto flex flex-col gap-4 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-slate"></div>
            
            <div className="flex items-start gap-4">
              <div className="bg-brand-sand p-2 rounded-lg">
                <ShieldAlert className="w-6 h-6 text-brand-slate" />
              </div>
              <div>
                <h4 className="text-lg font-heading text-brand-slate mb-1">Sua Privacidade</h4>
                <p className="text-xs text-brand-ink/80 leading-relaxed">
                  Utilizamos cookies de segurança essenciais e tecnologias de análise (Analytics) para personalizar o conteúdo jurídico e facilitar o contato direto com nossos advogados.
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-2 mt-2 w-full pt-4 border-t border-brand-slate/5">
              <button onClick={handleAcceptEssential} className="btn-secondary text-xs px-4 flex-1">
                Apenas Essenciais
              </button>
              <button onClick={handleAcceptAll} className="btn-primary text-xs px-4 flex-1 bg-brand-slate border-brand-slate hover:bg-brand-ink hover:border-brand-ink">
                Aceitar Todos
              </button>
            </div>
            
            <a href="#" className="text-center text-[10px] text-brand-slate underline mt-2">
                Ler Política de Privacidade
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
